// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"7d4f706b5aece898","777":"7ab556b3c057329f"}[chunkId] + ".js";
};